export enum NotificationType {
  NEW_RSVP = "new_rsvp",
  ASO_EBI_SALE = "aso_ebi_sale",
  NEW_WELL_WISH = "new_well_wish",
  // Support no longer posts to the notification drawer/badge (it has its own
  // support-icon unread). These are kept for filtering out any legacy records.
  SUPPORT_REPLY = "support_reply",
  SUPPORT_TICKET = "support_ticket",
}

export interface RSVPEventData {
  guestName: string;
  guestEmail: string;
  inviteStatus: string;
  rsvpComingFor: string;
  rsvpRelationship: string;
  guestId: string;
}

export interface AsoEbiSaleEventData {
  buyerName: string;
  buyerEmail: string;
  buyerPhone: string;
  items: string;
  amount: number;
  transactionId: string;
  deliveryAddress: string;
}

export interface WellWishEventData {
  authorName: string;
  wishType: string;
  message: string;
  wellWishId: string;
  creationCtx: string;
  isFreeWish: boolean;
}

export interface SupportReplyEventData {
  feedbackId: string;
}

export type NotificationData =
  | RSVPEventData
  | AsoEbiSaleEventData
  | WellWishEventData
  | SupportReplyEventData;

export interface Notification {
  _id: string;
  weddingId: string;
  type: NotificationType;
  title: string;
  message: string;
  data: NotificationData;
  createdAt: string;
  expiresAt: string;
}

export interface NotificationsResponse {
  notifications: Notification[];
}